(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1770],{

/***/ 62034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(65067),
    isFlattenable = __webpack_require__(95882);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 93401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(24303),
    isArrayLike = __webpack_require__(67878);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 23813:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(50343),
    baseGet = __webpack_require__(13324),
    baseIteratee = __webpack_require__(68286),
    baseMap = __webpack_require__(93401),
    baseSortBy = __webpack_require__(27095),
    baseUnary = __webpack_require__(47826),
    compareMultiple = __webpack_require__(18477),
    identity = __webpack_require__(23059),
    isArray = __webpack_require__(86152);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 27095:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 27520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4795);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 18477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(27520);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 95882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(62034),
    baseOrderBy = __webpack_require__(23813),
    baseRest = __webpack_require__(36060),
    isIterateeCall = __webpack_require__(82406);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 34157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rq": function() { return /* reexport */ useCustomersQuery; },
  "Rw": function() { return /* reexport */ useMoreCustomersQuery; },
  "c5": function() { return /* reexport */ useStoryQuery; }
});

// UNUSED EXPORTS: createFetchCustomersThumbnailsQuery, fetchAllCustomers, fetchAllStoriesSlugs, fetchCustomers, fetchFeaturedCustomers, fetchFilters, fetchMetaData, moreCustomersQuery, storyQuery

// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/api/routes/customers/queries/customersFiltersQuery.ts




var createNameFromContentTypeId = function createNameFromContentTypeId(id, prefix) {
  return id.replace(prefix, "").replace(/([A-Z])/g, " $1").trim();
};

var createNormalizedId = function createNormalizedId(name) {
  var trimmedName = name.trim().replace(" ", "");

  if (trimmedName.length > 0) {
    var firstChar = trimmedName[0].toLowerCase();
    return firstChar + trimmedName.slice(1);
  }

  return name;
};

var groupFilters = function groupFilters(filters) {
  return filters.reduce(function (acc, filter) {
    var contentTypeId = filter.sys.contentType.sys.id;
    var normalizedName = createNameFromContentTypeId(contentTypeId, "customerStoryCategory");
    var normalizedId = createNormalizedId(normalizedName);

    if (!acc[normalizedId]) {
      acc[normalizedId] = {
        title: normalizedName,
        items: []
      };
    }

    acc[normalizedId].items.push({
      type: normalizedName,
      title: filter.fields.title,
      id: filter.sys.id
    });
    acc[normalizedId].items = _sortBy(acc[normalizedId].items, function (item) {
      return item.title.toLowerCase();
    });
    return acc;
  }, {});
};

var fetchFilters = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var queries, responses, data, groupedFilters;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queries = [client.get("/content/rawEntries/customerStoryCategoryUseCase"), client.get("/content/rawEntries/customerStoryCategoryIndustry"), client.get("/content/rawEntries/customerStoryCategoryRegion"), client.get("/content/rawEntries/customerStoryCategoryProducts")];
            _context.next = 3;
            return Promise.all(queries);

          case 3:
            responses = _context.sent;
            data = responses.flatMap(function (response) {
              return response.items;
            });
            groupedFilters = groupFilters(data);
            return _context.abrupt("return", groupedFilters);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFilters(_x) {
    return _ref.apply(this, arguments);
  };
}()));
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
;// CONCATENATED MODULE: ../../libs/api/routes/customers/queries/customersMetadataQuery.ts
/* provided dependency */ var process = __webpack_require__(34406);



var keys = (/* unused pure expression or super */ null && (["customer-metaData"]));
var fetchMetaData = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var enabled, fetchWithCache, data, metaData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return createFsCacheProxy(keys, function () {
              return client.get("/content/rawEntries/customerStories");
            }, {
              enabled: enabled
            });

          case 3:
            fetchWithCache = _context.sent;
            _context.next = 6;
            return fetchWithCache();

          case 6:
            data = _context.sent;
            metaData = data.items.filter(function (item) {
              return item.sys.id === "3nUzEZIwvUXU7SRyMGBYRa";
            }).map(function (value) {
              return {
                socialTitle: value.fields.socialTitle,
                socialDescription: value.fields.socialDescription,
                socialImage: value.fields.socialImage
              };
            });
            return _context.abrupt("return", metaData[0]);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchMetaData(_x) {
    return _ref.apply(this, arguments);
  };
}()));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ../../libs/api/routes/customers/queries/customersQuery.ts
/* provided dependency */ var customersQuery_process = __webpack_require__(34406);




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var fetchAllCustomers = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var _data$items$0$fields$, _data$items, _data$items$, _data$items$$fields, _data$items$$fields$c;

    var enabled, clientGetWithCache, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(customersQuery_process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return createFsCacheProxy(["customers-fetch-all"], client.get, {
              enabled: enabled
            });

          case 3:
            clientGetWithCache = _context.sent;
            _context.next = 6;
            return clientGetWithCache("/content/rawEntries/customerStories");

          case 6:
            data = _context.sent;
            return _context.abrupt("return", (_data$items$0$fields$ = (_data$items = data.items) === null || _data$items === void 0 ? void 0 : (_data$items$ = _data$items[0]) === null || _data$items$ === void 0 ? void 0 : (_data$items$$fields = _data$items$.fields) === null || _data$items$$fields === void 0 ? void 0 : (_data$items$$fields$c = _data$items$$fields.customerStoriesOrdered) === null || _data$items$$fields$c === void 0 ? void 0 : _data$items$$fields$c.map(function (e) {
              return e.fields;
            })) !== null && _data$items$0$fields$ !== void 0 ? _data$items$0$fields$ : []);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAllCustomers(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var DEFAULT_LIMIT = 10;
var DEFAULT_OFFESET = 0;
var fetchCustomers = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client) {
    var filters,
        pagination,
        groupedFilterEntries,
        _pagination$offset,
        offset,
        _pagination$limit,
        limit,
        searchParams,
        result,
        _args2 = arguments;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            filters = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            pagination = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
            groupedFilterEntries = Object.entries(filters).filter(function (_ref3) {
              var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
                  options = _ref4[1];

              return options.length > 0;
            }).map(function (_ref5) {
              var _ref6 = (0,slicedToArray/* default */.Z)(_ref5, 2),
                  key = _ref6[0],
                  options = _ref6[1];

              return [key, JSON.stringify(options.map(function (o) {
                return o.value;
              }))];
            });
            _pagination$offset = pagination.offset, offset = _pagination$offset === void 0 ? DEFAULT_OFFESET : _pagination$offset, _pagination$limit = pagination.limit, limit = _pagination$limit === void 0 ? DEFAULT_LIMIT : _pagination$limit;
            searchParams = new URLSearchParams(groupedFilterEntries);
            searchParams.set("limit", limit.toString());
            searchParams.set("offset", offset.toString());
            _context2.next = 9;
            return client.get("/content/filter/customers?".concat(searchParams.toString()));

          case 9:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchCustomers(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchFeaturedCustomers = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client) {
    var max,
        data,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            max = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 5;
            _context3.next = 3;
            return fetchAllCustomers(client);

          case 3:
            data = _context3.sent.filter(function (item) {
              return item.featured;
            }).slice(0, max);
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchFeaturedCustomers(_x3) {
    return _ref7.apply(this, arguments);
  };
}()));
var createFetchCustomersThumbnailsQuery = function createFetchCustomersThumbnailsQuery(client, _ref8) {
  var filters = _ref8.filters;
  return [["customers", "fetchCustomers", filters !== null && filters !== void 0 ? filters : null], /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_ref9) {
      var _ref9$pageParam, pagination, customers;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _ref9$pageParam = _ref9.pageParam, pagination = _ref9$pageParam === void 0 ? {} : _ref9$pageParam;
              _context4.next = 3;
              return fetchCustomers(client, filters, pagination);

            case 3:
              customers = _context4.sent;
              return _context4.abrupt("return", _objectSpread(_objectSpread({}, customers), {}, {
                items: customers.items.map(function (customer) {
                  var _customer$fields, _matchaLogo$fields, _matchaLogo$fields$lo, _matchaLogo$fields$lo2, _matchaLogo$fields$lo3;

                  var _ref11 = (_customer$fields = customer === null || customer === void 0 ? void 0 : customer.fields) !== null && _customer$fields !== void 0 ? _customer$fields : {},
                      company = _ref11.company,
                      slug = _ref11.slug,
                      title = _ref11.title,
                      matchaLogo = _ref11.matchaLogo;

                  return {
                    company: company,
                    slug: slug,
                    title: title,
                    logoUrl: matchaLogo === null || matchaLogo === void 0 ? void 0 : (_matchaLogo$fields = matchaLogo.fields) === null || _matchaLogo$fields === void 0 ? void 0 : (_matchaLogo$fields$lo = _matchaLogo$fields.logoColor) === null || _matchaLogo$fields$lo === void 0 ? void 0 : (_matchaLogo$fields$lo2 = _matchaLogo$fields$lo.fields) === null || _matchaLogo$fields$lo2 === void 0 ? void 0 : (_matchaLogo$fields$lo3 = _matchaLogo$fields$lo2.file) === null || _matchaLogo$fields$lo3 === void 0 ? void 0 : _matchaLogo$fields$lo3.url
                  };
                })
              }));

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref10.apply(this, arguments);
    };
  }()];
};
var useCustomersQuery = (0,createInfinityQueryHook/* default */.Z)(createFetchCustomersThumbnailsQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    var nextOffset = p.skip - p.limit;

    if (nextOffset < 0) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  },
  getNextPageParam: function getNextPageParam(p) {
    var nextOffset = p.skip + p.limit;

    if (p.total <= nextOffset) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  }
});
// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/utils/deterministicShuffle/deterministicShuffle.ts
var deterministicShuffle = __webpack_require__(575);
;// CONCATENATED MODULE: ../../libs/api/routes/customers/queries/singleCustomerStoryQuery.ts
/* provided dependency */ var singleCustomerStoryQuery_process = __webpack_require__(34406);




function singleCustomerStoryQuery_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function singleCustomerStoryQuery_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? singleCustomerStoryQuery_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : singleCustomerStoryQuery_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var singleCustomerStoryQuery_keys = ["customerStory-allStories"];

var fetchAllStories = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client) {
    var enabled, fetchWithCache, data;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enabled = Boolean(singleCustomerStoryQuery_process.env.ENABLE_FS_CACHE);
            _context2.next = 3;
            return (0,fsCache/* createFsCacheProxy */.c)(singleCustomerStoryQuery_keys, /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
              var rawResponse, description, nonEmptyData;
              return regenerator_default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return client.get("/content/rawEntries/customerStory");

                    case 2:
                      rawResponse = _context.sent;

                      if (rawResponse.items) {
                        _context.next = 7;
                        break;
                      }

                      description = rawResponse.toString();

                      if (typeof rawResponse === "object" && !Array.isArray(rawResponse) && rawResponse !== null) {
                        description = "Object with ".concat(Object.keys(rawResponse));
                      }

                      throw new Error("Got malformed response. Expected object with items property. Got ".concat(description));

                    case 7:
                      nonEmptyData = singleCustomerStoryQuery_objectSpread(singleCustomerStoryQuery_objectSpread({}, rawResponse), {}, {
                        items: rawResponse.items.filter(function (i) {
                          return i;
                        })
                      });
                      return _context.abrupt("return", nonEmptyData);

                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })), {
              enabled: enabled
            });

          case 3:
            fetchWithCache = _context2.sent;
            _context2.next = 6;
            return fetchWithCache();

          case 6:
            data = _context2.sent;
            return _context2.abrupt("return", data);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllStories(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchAllStoriesSlugs = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client) {
    var allStories;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchAllStories(client);

          case 2:
            allStories = _context3.sent;
            return _context3.abrupt("return", allStories === null || allStories === void 0 ? void 0 : allStories.items.map(function (i) {
              var _i$fields;

              return i === null || i === void 0 ? void 0 : (_i$fields = i.fields) === null || _i$fields === void 0 ? void 0 : _i$fields.slug;
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchAllStoriesSlugs(_x2) {
    return _ref3.apply(this, arguments);
  };
}()));
var storyQuery = function storyQuery(client, storySlug) {
  return [["customerStory/storyQuery", storySlug], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var allStories, storyData;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetchAllStories(client);

          case 3:
            allStories = _context4.sent;
            storyData = allStories.items.find(function (s) {
              return s.fields.slug === storySlug;
            });

            if (storyData) {
              _context4.next = 7;
              break;
            }

            throw new Error("Story data is empty");

          case 7:
            return _context4.abrupt("return", storyData);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to find story with ".concat(storySlug, ".\nUnderlying error: ").concat(_context4.t0));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 10]]);
  }))];
};
var useStoryQuery = (0,createQueryHook/* default */.Z)(storyQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
var moreCustomersQuery = function moreCustomersQuery(client, _ref5) {
  var slug = _ref5.slug,
      random = _ref5.random,
      amount = _ref5.amount;
  return [["customerStory/moreCustomersQuery", slug, random, amount], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
    var allStories;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fetchAllStories(client);

          case 2:
            allStories = _context5.sent;
            return _context5.abrupt("return", random ? (0,deterministicShuffle/* default */.Z)(allStories.items, random).slice(0, amount) : allStories.items.slice(0, amount));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }))];
};
var useMoreCustomersQuery = (0,createQueryHook/* default */.Z)(moreCustomersQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/customers/queries/index.ts





/***/ }),

/***/ 49976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ Row; },
  "Z": function() { return /* reexport */ CustomerCard; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CustomerCard/CustomerCard.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "ef53ll1"
} : 0)("display:grid;grid-auto-flow:row;align-content:space-between;text-decoration:none;width:100%;height:160px;background-image:", function (_ref) {
  var staticBackgroundGradient = _ref.staticBackgroundGradient;
  return staticBackgroundGradient;
}, ",url(", function (_ref2) {
  var img = _ref2.img;
  return img;
}, ");border-radius:10px;padding:24px 24px 18px;background-size:cover;background-position:center;transition:background-color 0.3s;position:relative;", function (_ref3) {
  var hoverable = _ref3.hoverable,
      img = _ref3.img,
      hoverBackgroundColor = _ref3.hoverBackgroundColor,
      beforeHoverBackgroundGradient = _ref3.beforeHoverBackgroundGradient,
      beforeHoverBackgroundBlendMode = _ref3.beforeHoverBackgroundBlendMode,
      afterHoverBackgroundGradient = _ref3.afterHoverBackgroundGradient,
      afterHoverBackgroundBlendMode = _ref3.afterHoverBackgroundBlendMode;
  return hoverable &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("background-color:", hoverBackgroundColor, ";background-image:", beforeHoverBackgroundGradient, ",url(", img, ");background-blend-mode:", beforeHoverBackgroundBlendMode, ";mix-blend-mode:normal;:hover{background-color:transparent;}&:before{position:absolute;content:'';top:0;right:0;bottom:0;left:0;width:100%;height:auto;background-image:", afterHoverBackgroundGradient, ",url(", img, ");background-blend-mode:", afterHoverBackgroundBlendMode, ";border-radius:10px;padding:24px 24px 18px;background-size:cover;background-position:center;z-index:0;opacity:0;transition:opacity 0.3s;}&:hover::before{opacity:1;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("sm");
}, "{height:360px;}" + ( true ? "" : 0));
var RowWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ef53ll0"
} : 0)( true ? {
  name: "1739oy8",
  styles: "z-index:1"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CustomerCard/CustomerCard.tsx


var _excluded = ["tokens", "img", "children", "hoverable", "href", "tag"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseCustomerCard = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      img = _ref.img,
      children = _ref.children,
      _ref$hoverable = _ref.hoverable,
      hoverable = _ref$hoverable === void 0 ? false : _ref$hoverable,
      href = _ref.href,
      tag = _ref.tag,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread(_objectSpread({
    as: tag,
    img: img,
    hoverable: hoverable,
    href: href,
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});

var defaultHoverGradient = function defaultHoverGradient(theme) {
  return "linear-gradient(\n  180deg,\n  ".concat((0,polished_esm/* transparentize */.DZ)(1, theme.palette.brand.darkAcai[800]), " 50%,\n  ").concat((0,polished_esm/* transparentize */.DZ)(0.8, theme.palette.neutrals.black[100]), " 100%\n),\nlinear-gradient(\n  0deg,\n  ").concat((0,polished_esm/* transparentize */.DZ)(0.84, theme.palette.brand.darkAcai[800]), " 33%,\n  ").concat((0,polished_esm/* transparentize */.DZ)(0.2, theme.palette.brand.darkAcai[600]), " 95%\n)");
};

var defaultTheme = function defaultTheme(theme) {
  return {
    staticBackgroundGradient: "linear-gradient(\n    180deg,\n    ".concat((0,polished_esm/* transparentize */.DZ)(1, theme.palette.brand.darkAcai[800]), " 100%,\n    ").concat((0,polished_esm/* transparentize */.DZ)(0.2, theme.palette.neutrals.black[100]), " 100%\n  ),\n  linear-gradient(\n    0deg,\n    ").concat((0,polished_esm/* transparentize */.DZ)(0.84, theme.palette.brand.darkAcai[800]), " 50%,\n    ").concat((0,polished_esm/* transparentize */.DZ)(0.2, theme.palette.neutrals.black[100]), " 100%\n  )"),
    hoverBackgroundColor: theme.palette.brand.darkAcai[600],
    beforeHoverBackgroundGradient: defaultHoverGradient(theme),
    afterHoverBackgroundGradient: defaultHoverGradient(theme),
    afterHoverBackgroundBlendMode: "luminosity",
    beforeHoverBackgroundBlendMode: "luminosity"
  };
};

var twilioLightStaticBackgroundGradient = function twilioLightStaticBackgroundGradient(theme) {
  return "\nlinear-gradient(\n  180deg,\n  ".concat((0,polished_esm/* transparentize */.DZ)(0.86, theme.palette.twilio.gray[80]), " 50%,\n  ").concat((0,polished_esm/* transparentize */.DZ)(0.3, theme.palette.twilio.gray[80]), " 100%\n  ),\nlinear-gradient(\n  0deg,\n  ").concat((0,polished_esm/* transparentize */.DZ)(0.86, theme.palette.twilio.gray[80]), " 50%,\n  ").concat((0,polished_esm/* transparentize */.DZ)(0.3, theme.palette.twilio.gray[80]), " 100%\n  )");
};

var CustomerCard = (0,useDesignTokens/* withDesignTokens */.Y)(BaseCustomerCard, function () {
  return {};
}, {
  light: defaultTheme,
  dark: defaultTheme,
  twilioLight: function twilioLight(theme) {
    return {
      staticBackgroundGradient: twilioLightStaticBackgroundGradient(theme),
      hoverBackgroundColor: theme.palette.twilio.gray[20],
      beforeHoverBackgroundGradient: "linear-gradient(\n        0deg,\n        ".concat(theme.palette.twilio.gray[20], ", \n        ").concat(theme.palette.twilio.gray[20], "\n        ),\n      linear-gradient(\n        180deg,\n        ").concat((0,polished_esm/* transparentize */.DZ)(0.8, theme.palette.twilio.gray[80]), " 50%, \n        ").concat(theme.palette.twilio.gray[80], " 100%\n        ),\n      linear-gradient(\n        0deg,\n        ").concat((0,polished_esm/* transparentize */.DZ)(0.8, theme.palette.twilio.gray[80]), " 50%, \n        ").concat(theme.palette.twilio.gray[80], " 100%\n        )"),
      afterHoverBackgroundGradient: twilioLightStaticBackgroundGradient(theme),
      beforeHoverBackgroundBlendMode: "color, multiply, multiply, normal",
      afterHoverBackgroundBlendMode: "multiply, multiply, normal"
    };
  }
});
var Row = function Row(_ref2) {
  var children = _ref2.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RowWrapper, {
    children: children
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CustomerCard/index.ts

CustomerCard.displayName = "CustomerCardBase";
Row.displayName = "CustomerCard.Row";


/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58586);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates infinite query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useInfiniteQuery
 */

var createInfiniteQueryHook = function createInfiniteQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery.apply */ .N.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createInfiniteQueryHook);

/***/ }),

/***/ 575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shuffleWithSeed */
// SOURCE: https://github.com/yixizhang/seed-shuffle

/**
 * This is an util to generate a shuffled array, with deterministic randomness provided by the seed.
 *
 * @param array - The array to be shuffled
 * @param seed - The seed to generate the randomness
 * @returns The shuffled array
 */
var shuffleWithSeed = function shuffleWithSeed(array) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1332712639;
  var currentIndex = array.length;
  var temporaryValue;
  var randomIndex;
  seed = seed || 1;

  var random = function random() {
    var x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  }; // While there remain elements to shuffle...


  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(random() * currentIndex);
    currentIndex -= 1; // And swap it with the current element.

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

var deterministicShuffle = function deterministicShuffle(array, someRandom) {
  return shuffleWithSeed(array, someRandom);
};

/* harmony default export */ __webpack_exports__["Z"] = (deterministicShuffle);

/***/ }),

/***/ 58586:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(36370);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(91578);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(54388);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 4 modules
var useBaseQuery = __webpack_require__(53997);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ }),

/***/ 95922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64034);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17602);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57211);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42330);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

}]);